import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { AssignmentTypeOption } from "@redotech/redo-return-core-common/return-flow/condition-enums";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import * as React from "react";
import {
  ConditionType,
  ConditionTypeDetailsProps,
} from "../../return-flow/condition";

export type AssignmentTypeState = Omit<Condition.AssignmentType, "type">;

export const ASSIGNMENT_TYPE = (
  Details: React.ComponentType<ConditionTypeDetailsProps<AssignmentTypeState>>,
): ConditionType<AssignmentTypeState, Condition.AssignmentType> => ({
  name: CONDITION_NAMES[Condition.ASSIGNMENT_TYPE],
  description(state) {
    return state.assignmentType;
  },
  Details(props: ConditionTypeDetailsProps<AssignmentTypeState>) {
    return React.createElement(Details, props);
  },
  empty: { assignmentType: AssignmentTypeOption.NO_ASSIGNEE },
  fromModel(model) {
    return { assignmentType: model.assignmentType };
  },
  toModel(state) {
    return { type: Condition.ASSIGNMENT_TYPE, ...state };
  },
  valid(state) {
    return !!state.assignmentType;
  },
});
